import React, { Component } from 'react'

class FlashDevice extends Component {
  render() {
    const { stepData } = this.props
    let content =
      stepData && stepData.packageFile.location.length > 1
        ? stepData.packageFile.location
        : stepData && stepData.lcdImage

    return (
      <div className="phone-container col-md-5">
        <If condition={content}>
          <If condition={stepData.packageFile.location.length > 1}>
            <object width={300} height={600} key={Math.uuid()}>
              <param name="movie" value={content} />
              <embed src={content} width={300} height={600}></embed>
            </object>
          </If>
          <If condition={stepData.packageFile.location.length <= 1}>
            <object
              width={stepData && 300}
              height={stepData && 600}
              data={content}
            >
              Error
            </object>
          </If>
        </If>
      </div>
    )
  }
}

export default FlashDevice



// WEBPACK FOOTER //
// ./src/components/FlashDevice/FlashDevice.js